import salesResult from './salesResult'
export default {
  components: { salesResult },
  data() {
    return {
      salesResultVisible: false
    }
  },
  methods: {
    showSalesResult(row) {
      this.rowData = row;
      this.salesResultVisible = true;
    }
  }
}